

















import { mergeShopifyProductCards } from 'library/helpers/products'
import ProductCard from '../globals/cards/product/product-card'

export default
	components: {
		ProductCard
	}

	props:
		block: Object

		# Used to pass in product card entries that already have Shopify data
		# merged in, like from Algolia search results
		mergedProducts: Array

	# Hydrated with mergedProducts if they exist
	data: -> products: @mergedProducts || []

	computed:
		classes: -> [
			'center-content' if @products.length < 3
		]

	# Don't fetch if mergedProducts were passed in or if the block has no products
	fetch: ->
		return if @mergedProducts?.length or !@block?.products?.length
		@products = @block.products
		@products = await mergeShopifyProductCards @products

